import React from 'react';
import classNames from 'classnames';
import faqData from './faqs-data';

// accordion built on the design system's faq-* styles
export default class ContactFaqs extends React.Component {
  render() {
    return (
      <div className="faq-inner">
        {faqData.map((item, index) => <FaqItem key={item.title} item={item} id={`faq-${index}`} />)}
      </div>
    );
  }
}

class FaqItem extends React.Component {
  constructor() {
    super();
    this.state = {
      open: false,
    };

    this.onClick = this.onClick.bind(this);
  }

  onClick() {
    this.setState({
      open: !this.state.open,
    });
  }

  render() {
    const { item, id } = this.props;
    const { open } = this.state;

    return (
      <div className={classNames('faq-item', { open })}>
        <button type="button" className="faq-q" onClick={this.onClick} aria-expanded={open} aria-controls={id}>
          {item.title}
          <span className="faq-arrow" aria-hidden="true">+</span>
        </button>
        <div className="faq-a" id={id} role="region">
          <p>{item.content}</p>
        </div>
      </div>
    );
  }
}
